<template>
  <div class="atomic-district">
    <md-checkbox
      :checked="district.isChecked"
      type="checkbox"
      name="district"
      @change="onChange"
    >
      {{ $i18n.locale === 'en'? district.name_en : district.name_zh }}
    </md-checkbox>
  </div>
</template>

<script>
import MdCheckbox from '@/components/MaterialCheckbox';

export default {
  props: ['district'],
  components: {
    MdCheckbox,
  },
  methods: {
    onChange() {
      const checked = !this.district.isChecked;
      this.$emit('changeDistrict', {
        [this.district.dist_code]: checked,
      });
    },
  },
};
</script>

<style scoped>
.atomic-district {
  display: inline-block;
  margin-right: 5px;
}
</style>
